import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getPropsDataGrid, getPropsLookupExprForIdText } from "../../../../../utils/default-props";
import { useDataSource } from "../../../../../contexts/dataSource";
import { getDataGridCustomToolbarCaption } from "../../../../../components/default-components/data-grid-custom-toolbar";
import DataGrid, { Column, ColumnChooser, Editing, FilterPanel, FilterRow, HeaderFilter, Item, Lookup, SearchPanel, Toolbar } from "devextreme-react/data-grid";
import { lookupGroups } from "../../../../../utils/lookup-groups.ts";
import { useAuth } from "../../../../../contexts/auth";
import { useLookupGroup } from "../../../../../contexts/lookup-group-context.js";
import { usePublicEvents } from "../../../../../contexts/public-events.js";
import { useNavigate } from "react-router-dom";

function LeaveInfoList() {

    const navigate = useNavigate();
    const { dataSourceHR } = useDataSource()
    const { user, activeLanguage } = useAuth()
    const [id, setId] = useState()
    const [leavePaymentType, setLeavePaymentType] = useState()
    const [leaveCalculationMethod, setLeaveCalculationMethod] = useState()
    const [leaveLimitType, setLeaveLimitType] = useState()
    const [leaveAccrualPeriodType, setLeaveAccrualPeriodType] = useState()
    const [leaveUsageMethod, setLeaveUsageMethod] = useState()
    const { getLookupData } = useLookupGroup()
    const { setPublicAddEvent } = usePublicEvents()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: "/api/LeaveInfo",
        insertUrl: "/api/LeaveInfo/FormData",
    }), [])

    const handleRowDblClick = (e) => {
        if (id) navigate(`/leave-management/leave-management-card/${id}`)
    }

    const handleFocusedRowChange = (e) => {
        setId(e.component.option('focusedRowKey'));

    }
    // const dbLookUp = useCallback((type) => {
    //     console.log("dbLookUp  tetiklendi", type)
    //     return dataSourceHR({
    //         loadUrl: `/api/LookupData/LookupGroup/${type}`,
    //         loadMode: "raw"
    //     })
    // }, [user, activeLanguage])

    // const getEditProperties = useCallback((type) => {
    //     console.log("getEditProperties tetiklendi", type)
    //     return {
    //         dataSource: dbLookUp(type),
    //         layout: "horizontal",
    //         valueExpr: "id",
    //         displayExpr: "text"
    //     }
    // }, [user, activeLanguage])

    // //const leavePaymentTypeEditProperties = useMemo(() => getEditProperties(lookupGroups.LeavePaymentType), [])
    // const dbLeavePaymentType = useMemo(() => dataSourceHR({
    //     loadUrl: `/api/LookupData/LookupGroup/${lookupGroups.leavePaymentType.id}`
    // }), [activeLanguage])

    // const dbLeaveCalculationMethod = useMemo(() => dataSourceHR({
    //     loadUrl: `/api/LookupData/LookupGroup/${lookupGroups.leaveCalculationMethod.id}`
    // }), [activeLanguage])

    // const dbLeaveLimitType = useMemo(() => dataSourceHR({
    //     loadUrl: `/api/LookupData/LookupGroup/${lookupGroups.leaveLimitType.id}`
    // }), [activeLanguage])

    // const dbLeaveAccrualPeriodType = useMemo(() => dataSourceHR({
    //     loadUrl: `/api/LookupData/LookupGroup/${lookupGroups.leaveAccrualPeriodType.id}`
    // }), [activeLanguage])

    // const dbLeaveUsageMethod = useMemo(() => dataSourceHR({
    //     loadUrl: `/api/LookupData/LookupGroup/${lookupGroups.leaveUsageMethod.id}`
    // }), [activeLanguage])

    useEffect(() => {
        //console.log("lookupGroups.leavePaymentType",lookupGroups.leavePaymentType)
        getLookupData(lookupGroups.leavePaymentType).then(response => setLeavePaymentType(response))
        getLookupData(lookupGroups.leaveCalculationMethod).then(response => setLeaveCalculationMethod(response))
        getLookupData(lookupGroups.leaveAccrualPeriodType).then(response => setLeaveAccrualPeriodType(response))
        getLookupData(lookupGroups.leaveUsageMethod).then(response => setLeaveUsageMethod(response))

    }, [activeLanguage])


    useEffect(() => {
        if (setPublicAddEvent)
            setPublicAddEvent(() => {
                return () => { navigate('/leave-management/leave-management-card') }
            })

        return () => {
            if (setPublicAddEvent)
                setPublicAddEvent(undefined)
        }

    }, [])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    {/* <div className="grid-caption">Employe List</div> */}

                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        focusedRowKey={id}
                        onFocusedRowChanged={handleFocusedRowChange}
                        onRowDblClick={handleRowDblClick}
                        remoteOperations={false}
                        showRowLines={false}
                        height="70vh"

                    >
                        <Toolbar>

                            {getDataGridCustomToolbarCaption("İzin Tanımları Listesi")}
                            <Item name="addRowButton" />
                            <Item name="searchPanel" />
                            <Item name="columnChooserButton" />

                        </Toolbar>
                        {/* <FilterRow visible={true} /> */}
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <SearchPanel visible />
                        <ColumnChooser enabled />
                        <Editing
                            allowDeleting={true}
                        // allowAdding={true}
                        />

                        <Column dataField="name" caption="İzin Tanımı" width={300} />
                        <Column dataField="name1" caption="İzin Türü" />

                        <Column dataField="leavePaymentTypeId" caption="İzin Ücret Türü" >
                            <Lookup dataSource={leavePaymentType} {...getPropsLookupExprForIdText} />
                        </Column>
                        <Column dataField="leaveCalculationMethodId" caption="İzin Hesaplama" >
                            <Lookup dataSource={leaveCalculationMethod} {...getPropsLookupExprForIdText} />
                        </Column>
                        <Column dataField="duration" caption="İzin Süresi" />

                        {/* <Column dataField="isPeriodic" caption="Periyodik İzin" />
                        <Column dataField="leaveAccrualPeriodTypeId" caption="İzin Hakediş Periyodu" >
                            <Lookup dataSource={leaveAccrualPeriodType} {...getPropsLookupExprForIdText} />
                        </Column>
                        <Column dataField="isTransferable" caption="Devredilebilir" />
                        <Column dataField="leaveLimitTypeId" caption="Limit Türü" >
                            <Lookup dataSource={leaveLimitType} {...getPropsLookupExprForIdText} />
                        </Column>
                        <Column dataField="expiryPeriod" caption="Geçerlilik Süresi(ay)" />
                        <Column dataField="isAdvanceAllowed" caption="Avans Kullanılabilir" />
                        <Column dataField="advanceLimit" caption="Avans Limiti" />
                        <Column dataField="leaveUsageMethodId" caption="İzin Kullanım Methodu" >
                            <Lookup dataSource={leaveUsageMethod} {...getPropsLookupExprForIdText} />
                        </Column>
                        <Column dataField="maxLimitForSingleUsage" caption="Tek Seferde Kullanılabilecek Kasimum Miktar" />
                        <Column dataField="minLimitForSingleUsage" caption="Tek Seferde Kullanılabilecek Minimum Miktar" />
                        <Column dataField="isDocumentRequired" caption="Döküman Gerekli" />
                        <Column dataField="isStandInEmployeeRequired" caption="Yerine Personel Gerekli" />
                        <Column dataField="isBalanceTracking" caption="Bakiye Zorunlu" />
                        <Column dataField="isAddressRequired" caption="Adres Zorunlu" />
                        <Column dataField="isExplanationRequired" caption="Açıklama Zorunlu" /> */}
                        <Column dataField="id" caption="id" visible={false} />
                    </DataGrid>

                    {/* <Button onClick={() => { navigate('/leave-management/leave-management-card') }}>Yeni Kayit</Button>
                    <Button onClick={() => { if (id) navigate(`/leave-management/leave-management-card/${id}`) }}>Düzenle</Button> */}
                </div>
            </div>
        </React.Fragment>
    )
}

export default LeaveInfoList;